export default {_name:'button.menu.action',module:'Field',view:'Element/Menu/Item/Action',options:{key:'action',value:'test',events:{onOpen:'onActionOpen'}}}